import { Switch } from "@progress/kendo-react-inputs";

function TooltipCell({ dataItem, hidden, pages, onChange }) {

    function handleChange(event) {
        onChange(event, dataItem);
    }

    return (
        <td>
            <Switch
                disabled={
                    (
                        hidden ||
                        dataItem.attributeType === "Phone" ||
                        dataItem.attributeType === "Html" ||
                        dataItem.attributeType === "TreePath" ||
                        dataItem.attributeType === "Image"
                    )
                }
                onChange={handleChange}
                checked={dataItem.tooltip} />
        </td>
    )
}

export default TooltipCell;